import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    blue: {
      95: '#E6F0FF', // Background or light
      90: '#CCE0FF', // Tag
      75: '#80B2FF',
      50.4: '#0064FF66',
      50.25: '#0064FF40',
      50: '#0064FF', // Main
      35: '#0047B3', // Hover
      20: '#002866',
      15: '#001C41' // Footer ChileCompra
    },
    brand: {
      black1: '#2E384D',
      black2: '#536479',
      black3: '#768AA2',
      blank: '#FFFFFF',
      dialogBorder: '#EFF2FF',
      disable: '#768AA2',
      disableButton: '#D5D7DB',
      disableFont: '#768AA2',
      error: '#E22C2C',
      gray1: '#B3BECB',
      gray2: '#D1D8E0',
      gray3: '#F3F5F7',
      primary: '#0064FF',
      success: '#2FA12B',
      warning: '#F7C137',
      white: '#FFFFFF'
    },
    gray: {
      100: '#FFFFFF',
      95: '#F3F5F7', // gray3
      90: '#E4E8EC',
      85: '#D1D8E0', // gray2
      75: '#B3BECB', // gray1
      50.5: '#768AA280',
      50.4: '#768AA266',
      50: '#768AA2', // black3
      35: '#536479', // black2
      20: '#2E384D', // black1
      0.16: '#00000029',
      0.8: '#00000014',
      0.5: '#00000080',
      0.4: '#0000000A'
    },
    green: {
      95: '#E7F9E7',
      90: '#D4F3D3',
      75: '#99E396',
      50.4: '#2FA12B66',
      50: '#2FA12B',
      35: '#237920'
    },
    orange: {
      95: '#FFECDC',
      90: '#FEDBBD',
      75: '#FEAE6C',
      50.4: '#FD7E1466',
      50: '#FD7E14',
      35: '#B65402'
    },
    red: {
      95: '#FCE9E9',
      90: '#F9D2D2',
      75: '#F08F8F',
      50.5: '#E22C2C80',
      50.4: '#E22C2C66',
      50: '#E22C2C',
      35: '#9D1616'
    },
    yellow: {
      95: '#FEF4DD',
      90: '#FCEBBF',
      75: '#FAD780',
      50.4: '#F7C13766',
      50: '#F7C137',
      35: '#AB7D07'
    },
    // This correspond to MP palette color for transversal menu and header buttons
    MP: {
      black: '#000000',
      congressBlue: '#034C87',
      corduroy: '#585959',
      default: {
        hover: '#044076',
        main: '#888888'
      },
      endeavour: '#0667B4',
      mountainMeadow: '#1ABC9C',
      primary: {
        hover: '#044076',
        main: '#337AB7'
      },
      regalBlue: '#044076',
      veniceBlue: '#065C94'
    }
  },
  typography: {
    families: {
      roboto: ['Roboto', 'sans-serif'].join(','),
      robotoMono: ['Roboto+Mono', 'monospace'].join(',')
    },
    fontFamily: ['Roboto', 'sans-serif'].join(','),
    htmlFontSize: 10,
    useNextVariants: true
  }
})

export default theme
